import type { PersistentDebugLogger } from '@/hooks/telemetry/use-persistent-debug-logger';
import type { Viewport } from '@/theme/breakpoints';
import type { CstretchmodalViewportModel } from './Cstretchmodal.types';
import { useCstretchmodalDebugTelemetry } from './useCstretchmodalDebugTelemetry';
import { useCstretchmodalEscapeKey } from './useCstretchmodalEscapeKey';

interface UseCstretchmodalLifecycleInput {
  canClose: boolean;
  compactAsMobile: boolean;
  debugContext?: Record<string, unknown>;
  debugLogger: PersistentDebugLogger;
  debugName?: string;
  handleClose: () => void;
  isTop: boolean;
  modalId: string;
  overlayPortalTargetId?: string;
  showBackButton: boolean;
  viewport?: Viewport | null;
  viewportModel: CstretchmodalViewportModel;
  visible: boolean;
}

export function useCstretchmodalLifecycle({
  canClose,
  compactAsMobile,
  debugContext,
  debugLogger,
  debugName,
  handleClose,
  isTop,
  modalId,
  overlayPortalTargetId,
  showBackButton,
  viewport,
  viewportModel,
  visible,
}: UseCstretchmodalLifecycleInput): void {
  useCstretchmodalDebugTelemetry({
    debugName,
    isTop,
    debugLogger,
    modalId,
    visible,
    canClose,
    viewport,
    isMobile: viewportModel.isMobile,
    isCompact: viewportModel.isCompact,
    compactAsMobile,
    useMobileStyling: viewportModel.useMobileStyling,
    overlayPortalTargetId,
    showBackButton,
    debugContext,
  });

  useCstretchmodalEscapeKey({
    canClose,
    debugContext,
    debugLogger,
    debugName,
    handleClose,
    isTop,
    visible,
  });
}
